package org.solyton.solawi.bid.application.ui.page.user.`data`.sort

import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens
import org.solyton.solawi.bid.module.list.component.SortOrder

/**
 * Autogenerated Lens.
 * Read and manipulate [UserSortOrder.username]
 */
@ReadWrite
public val username: Lens<UserSortOrder, SortOrder> by lazy {
      Lens(
        get = { whole -> whole.username },
        set = { part -> { whole -> whole.copy(username = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UserSortOrder.username]
 */
@ReadWrite
public fun UserSortOrder.username(`set`: SortOrder.() -> SortOrder): UserSortOrder = copy(username =
    set(username))

/**
 * Autogenerated Lens.
 * Read and manipulate [UserSortOrder.status]
 */
@ReadWrite
public val status: Lens<UserSortOrder, SortOrder> by lazy {
      Lens(
        get = { whole -> whole.status },
        set = { part -> { whole -> whole.copy(status = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UserSortOrder.status]
 */
@ReadWrite
public fun UserSortOrder.status(`set`: SortOrder.() -> SortOrder): UserSortOrder = copy(status =
    set(status))

/**
 * Autogenerated Lens.
 * Read and manipulate [UserSortOrder.firstName]
 */
@ReadWrite
public val firstName: Lens<UserSortOrder, SortOrder> by lazy {
      Lens(
        get = { whole -> whole.firstName },
        set = { part -> { whole -> whole.copy(firstName = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UserSortOrder.firstName]
 */
@ReadWrite
public fun UserSortOrder.firstName(`set`: SortOrder.() -> SortOrder): UserSortOrder = copy(firstName
    = set(firstName))

/**
 * Autogenerated Lens.
 * Read and manipulate [UserSortOrder.lastName]
 */
@ReadWrite
public val lastName: Lens<UserSortOrder, SortOrder> by lazy {
      Lens(
        get = { whole -> whole.lastName },
        set = { part -> { whole -> whole.copy(lastName = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UserSortOrder.lastName]
 */
@ReadWrite
public fun UserSortOrder.lastName(`set`: SortOrder.() -> SortOrder): UserSortOrder = copy(lastName =
    set(lastName))
